/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $PlayerCareerCreate = {
    properties: {
        position: {
            type: 'PlayerPositionEnum',
            isRequired: true,
        },
        dateFrom: {
            type: 'string',
            isRequired: true,
            format: 'date',
        },
        dateTo: {
            type: 'any-of',
            contains: [{
                type: 'string',
                format: 'date',
            }, {
                type: 'null',
            }],
            isRequired: true,
        },
        careerType: {
            type: 'CareerType',
            isRequired: true,
        },
        teamName: {
            type: 'string',
            isRequired: true,
        },
        leagueName: {
            type: 'string',
            isRequired: true,
        },
        imageId: {
            type: 'any-of',
            contains: [{
                type: 'string',
            }, {
                type: 'null',
            }],
            isRequired: true,
        },
    },
} as const;
